<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<template>
  <div>
    <h2>La Convención de Londres</h2>
    <img @click="imageClicked(0)" src="galerias/sala1/S1_G8.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>La Convención de Londres</b><br>
        Técnica: Reprografía<br>
        Obtenida de “La crónica de hoy, Jalisco”<br>
    </p>
    <br>
    <p>Alegando una conducta arbitraria e injusta por parte del gobierno mexicano, España, Inglaterra y Francia realizaron una Convención en Londres, en la que pactaron y firmaron, el 31 de octubre de 1861, los siguientes acuerdos: enviar a las costas de México fuerzas combinadas por mar y tierra, para ocupar fortalezas y posiciones militares del litoral mexicano, no buscar ninguna adquisición de territorio ni ventaja alguna particular y no incidir o afectar el derecho de la nación mexicana a establecer la forma de su gobierno. No obstante los acuerdos, estos no se cumplieron.</p>
    <p>Buscando evitar reclamos por parte de Estados Unidos por la inminente intervención europea en territorio mexicano, se le envió copia de los acuerdos tomados en la Convención de Londres.</p>
    <p>El 7 de diciembre de 1861 arribó al puerto de Veracruz la flota española con 5,789 hombres, un mes después llegaron los ejércitos de Inglaterra con 700 marines y Francia con 3,000. Algunas tropas se establecieron en Xalapa y otras en Orizaba, ambos en el estado de Veracruz.</p>
    <h5>Ver más:</h5>
    <p>
        Si quieres conocer los artículos de la Convención de Londres, visita: <a target="_blank" href="https://archivos.juridicas.unam.mx/www/bjv/libros/12/5625/27.pdf">archivos.juridicas.unam.mx</a>
        Fuente de la imagen: <a target="_blank" href="https://www.cronicajalisco.com/notas-el_espejo_histOrico_intervencion_francesa_suspension_de_pagos_y_la_convencion_de_londres_ii-100200-2020">www.cronicajalisco.com</a>
    </p>
    <h3>México: un país vulnerable </h3>
    <img @click="imageClicked(1)" src="galerias/sala1/S1_G8_SUB.jpg" class="mainphoto"/>
    <p class="photo-description">Título: <b>Soldados de la armada mexicana</b><br>
        Autor: Janet Lange <br>
        Año: 1863<br>
        Técnica:Litografía <br>
        Medidas: 37.27 x 28.7 <br>
        Colección: La Ilustración: periódico semanal universal.<br>        
    </p>
    <p>A raíz de los problemas internos de México, la prensa internacional, particularmente  inglesa y francesa, hablaban de la necesidad de una intervención sobre México, considerado por ellos un país “salvaje e ingobernable”.</p>
    <p>Estados Unidos, a través de  Thomas Corwin, Ministro norteamericano, ofreció al gobierno mexicano el préstamo de 11 millones de pesos, con la condición de hipotecar como garantía una parte del territorio nacional. El acuerdo no llegó a concretarse.</p>
    <p>Por su parte, Lord Palmerston, Ministro Británico, anhelaba establecer una monarquía en México al igual que el emperador Napoleón III de Francia, quien era atraído por las importantes minas mexicanas, la estratégica ubicación del país para contar con una puerta política para América Latina y la recesión por la que atravesaba Estados Unidos. Por su parte, España aún añoraba el pasado y no perdía la esperanza de reinstalar su imperio.</p>
    <p>Lo anterior, es muestra de la vulnerabilidad e inestabilidad política que atravesaba el país y la avidez de expansión por parte de Estados Unidos y Europa.</p>
  </div>
</template>

<script>
export default {
  name: "s12g08",
  data() {
    return {};
  },
  methods: {
    imageClicked(idx) {
      this.$emit("onImageClicked", idx);
    },
  },
  components: {},
  props: {},
  mounted() {},
};
</script>
